import {commafyPlural, get_dur, isObject, isSearchInStrings, minUnitsBiz, objToArrK} from "../tools/CommonJS";
import {objToArrKH} from "../tools/CommonReact";

export const modulesDefs = {
    miscon: {h: "Misconfiguration", desc: "Devices with threats", objName: "device"},
    benchmark: {h: "Benchmark", desc: "Deviations", objName: "control"},
    ad: {h: "Active Directory", desc: "Threats and insights", objName: "setting"},
    gp: {h: "Policy Validation", desc: "Misconfigurations", objName: "GPO"},
    profiler: {h: "Profiler", desc: ""},
};

export const BenchmarkOrg = {
    miscon: "GYTPOL",
    cis: "CIS",
    appControl: "APP_CONTROL",
    osVuln: "PATCH_VULN_ASSESSMENT",
    appVuln: "APP_VULN_ASSESSMENT",
    osPatch: "OS_PATCH_MANAGEMENT"
};

export const currencySymbols = {
        USD: {s: "$", h: "$ US Dollars"},
        GBP: {s: "£", h: "£ British Pounds"},
        EU: {s: "€", h: "€ Euros"},
    }, currencySymbolsOpts = objToArrK(currencySymbols);

export const selTargetDefs = {
        "!server":              {h: "Win endpoints (inc. VDIs)", shortH: "Windows", desc: "Win endpoints", objName: "endpoint", color: "#537dee"},
        "global":               {h: "Trending Global Attack Vectors", desc: "Global concerning threats", objName: "#696F7F"},
        "vdi":                  {h: "VDIs", shortH: "VDIs", desc: "VDI endpoints", hCap: "VDIs", objName: "VDI", color: "#0e4380"},
        "kubernetes":           {h: "Kubernetes", shortH: "K8s", desc: "Kubernetes containers", objName: "VDI", color: "#93AAE7"},
        "mac":                  {h: "macOS", shortH: "macOS", desc: "Macs", objName: "devices", color: "#77C1E8"},
        "!vdi !server":         {h: "Win endpoints", shortH: "Windows", desc: "Non-VDI endpoints", objName: "endpoint", color: "#0090d9"},
        "server":               {h: "Win servers (inc. DCs)", shortH: "Windows", desc: "Win servers", objName: "server", color: "#0079be"},
        "dc":                   {h: "DCs", shortH: "Windows", desc: "Win DC servers", hCap: "DCs", objName: "Win Domain Controller", color: "#757ccc"},
        "server !dc":           {h: "Servers (non-DCs)", shortH: "Windows", desc: "Win Non-DC servers", objName: "server", color: "#FEAF88"},
        "debian":               {h: "Debian", shortH: "Linux", desc: "Linux Debian", objName: "devices", color: "#0079be"},
        "rhel":                 {h: "Red Hat", shortH: "Linux", desc: "Linux Red Hat", objName: "devices", color: "#0079be"},
        "suse":                 {h: "SUSE", shortH: "Linux", desc: "Linux SUSE", objName: "devices", color: "#93b4fd"},
        "networks":             {h: "Network Devices", shortH: "Network", desc: "Routers, switches and firewalls", objName: "network", color: "#049fd8"},
        "linux-unknown":        {h: "Others", shortH: "Linux", desc: "Other linuxes", objName: "devices", color: "#76859d"},
    //"fedora": {}, "gentoo": {}, "slackware": {}, "arch": {}, "exherbo": {}, "alpine": {}, "coreos": {}, "solus": {},
    }, selTargetOpts = objToArrK(selTargetDefs);


export const severitiesDefs = {
        High: {idx: 0, c: "threat", h: "Critical", bg: "bg-threat", tx: "text-tx-threat", border: "border-threat", color: "#ff5656"},
        Medium: {idx: 1, c: "medium", h: "Medium", bg: "bg-medium", tx: "text-medium", border: "border-medium", color: "#ff943d"},
        Low: {idx: 2, c: "warning", h: "Low", bg: "bg-warning", tx: "text-warning", border: "border-warning", color: "#fff162"},
        Passed: {idx: 3, c: "success", h: "Good", bg: "bg-success", tx: "text-success", border: "border-success", color: "#4ed37c"},
        Unknown: {idx: 4, c: "handle", h: "Unknown", bg: "bg-handle", tx: "text-tx-steel", border: "border-handle"},

        unknown: {idx: 5, c: "threat", h: "Non-Compliant", bg: "bg-threat", tx: "text-threat", border: "border-threat", color: "#ff5656"},
        passed: {idx: 6, c: "success", h: "Compliant", bg: "bg-success", tx: "text-success", border: "border-success", color: "#4ed37c"},

        Complied: {idx: 3, c: "success", h: "Good", bg: "bg-success", tx: "text-success", border: "border-success", color: "#4ed37c"},
        Uninstalled: {idx: 8, c: "success", h: "Uninstalled", bg: "bg-success", tx: "text-success", border: "border-success", color: "#4ed37c"},

    }, severitiesDefsArr = objToArrK(severitiesDefs);

export const formatSevForParam = (severities, defs) => {
    const defsArr = defs ? objToArrK(defs) : severitiesDefsArr;
    return !severities?.length? null : severities?.map(si => defsArr[si].k);
};
export const sortObjToSrv = o => ({by: o.k, dsc: o.dsc});

const notUsedInDayColors = ["#D17BC9", "#B58AE0", "#977FE6", "#7779EE", "#5A89E6", "#5AB1E6"];
export const notUsedInDaysOpts = [0, 30, 60, 90, 120, 180].map((days, i) => ({k: days, h: days ?`${days}+ days` : "Has Usage Data", color: notUsedInDayColors[i]}));

// Resolve the hex matching the notUsedInDaysOpts bucket the given day count falls into. Falls back to the pinkish 0-29d shade when below the first bucket.
export const notUsedInDaysColor = (days) => notUsedInDaysOpts.findLast(o => days >= o.k)?.color;

export const getBizDur = (m) => get_dur(m *1000, {altUnits: minUnitsBiz, topOnly: 1, addUnit: 2});

export const c_accessFull = "full", c_accessView = "read";
export const permAdmin = {groupId: 0, access: c_accessFull};

export const isGroupAll = groupId => !groupId;
export const isSameGroup = (a, b) => a === b || (isGroupAll(a) && isGroupAll(b));
export const checkRoleAdmin = perm => isGroupAll(perm?.groupId) && perm?.access === c_accessFull;
export const checkRoleViewOnly = perms => !perms?.some(perm => perm.access === c_accessFull);       // really noAnyFullAccess ;)

export const groupNameAll = "All my devices";
export const groupOptAll = {h: groupNameAll, k: 0};

export const dispGroupName = obj => {
    let {groupId, groupName} = (obj?.rowData ?? obj) || {};
    return isGroupAll(groupId)? groupNameAll : groupName || `(group id: ${groupId})`;
};

export function dispGroupNameById({groupId, groups}) {
    return !groups? null : dispGroupName(groups?.find(g => g.groupId === groupId));
}

export const arrToInpOpts = (arr) => arr.map(h => ({h, k: h}));

export const prepGroupTotalsForSum = (tgts) => {
    const donutProps = tgts.map(tgt => ({
        name: selTargetDefs[tgt.selTarget]?.h?.replace(/(Windows)/g, "Win"),
        value: tgt.devices,
    }));

    return donutProps.sort((a, b) => b.value - a.value);
};

export function jsonParse(json, silent) {
    try {
        return JSON.parse(json);
    } catch (err) {!silent && console.error(err);}
}

// export const arrToStr = (arr) =>  arr.reduce(acc, )

export function showAddInfo(cellData, flags) {
    const {oneLine, nameVal, sJoin} = flags || {};
    let addInfo = !cellData? {} : typeof cellData === "string" && jsonParse(cellData, true) || cellData;
    if (addInfo === "null") return null;
    if (typeof addInfo !== "object")
        return addInfo;
    if (addInfo.length === 1 && typeof addInfo[0] === "object") {
        if (!addInfo[0])
            return addInfo[0];
        addInfo = addInfo[0];
    } else if (["string", "number"].includes(typeof addInfo[0]))
        return addInfo.join(sJoin || (oneLine? ", " : "\n"));
    if (nameVal && typeof addInfo[0] === "object")
        addInfo = addInfo.reduce((acc, elm) => {
            const val = elm.value;
            acc[elm.name] = typeof val === "string" ? val : val && val.join("\n") || val;
            return acc;
        }, {});
    if (isObject(addInfo))
        return !oneLine ? objToArrKH(addInfo)
            : Object.entries(addInfo).map(entry => entry.join(": ")).join(", ");
}

export const showAddInfoLine_nameVal = obj => showAddInfo(obj, {oneLine: 1, nameVal: 1});

export function adjustAddInfoKeys(addInfo) {
    // remove key "And" which is a DSL based alert.
    return Array.isArray(addInfo) ? addInfo?.filter(v => !["and", "or"].includes(v?.h?.toLowerCase())) : addInfo;
}

export const alertOnlyOpt = [{h: "All Measures", k: false}, {h: "Live Alerts Only", k: true}];
export const miscOpt = ["All alerts", "Quick wins", "Pinned"].map((h) => ({h, k: h}));

export const doesSearchIncTpc = (repo, search) => isSearchInStrings(search, repo?.title, repo?.subj);

export const calcDollarsSaved = (alerts, FTE, itMin = 3) => alerts * itMin / minUnitsBiz.year * FTE;

export const calculateSaving = (repoRemedies, cur) => {
    const remItMin = Object.values(repoRemedies)[0]?.itMinutes || 2;
    const achieved = remItMin * cur.alertsRemediated;
    const potential = remItMin * cur.alertsRemediable;

    return {achieved, potential};
};

export const statusPillDefs = {
        repeated: {border: "border-warning/90", h: "Recurring", tip: val => commafyPlural(val, "alert") + " recurred since the alert has been remediated!"},
        pending: {border: "border-pending", h: "pending", tip: val => "View " + commafyPlural(val, "pending remediation task") +" in the Action Center."},
        mutedAlerts: {border: "border-[#c9b31699]", h: "Muted", tip: val => commafyPlural(val, "alert", ["is", "are"]) +" muted."},
        remediatedAlerts: {border: "border-prm-main", h: "Remediated", tip: val => commafyPlural(val, "alert", ["was", "were"]) +" remediated."},
        alertsNew: {h: "New", tip: val => commafyPlural(val, "new alert", ["has", "have"]) +" appeared.", className: (severity) => severitiesDefs[severity]?.border}
    }, statusPillArr = objToArrK(statusPillDefs);


export const periodDefs = {
        "1d": {h: "< 24h", c: "#b2d1ff", tip: "Devices scanned within the last 24 hours."},
        "3d": {h: "< 3d", c: "#86a8fc", tip: "Devices scanned within the last 3 days."},
        "1w": {h: "< 1w", c: "#0090d9", tip: "Devices scanned within the last week."},
        "2w": {h: "< 2w", c: "#0e4380", tip: "Devices scanned within the last 2 weeks."}
    }, periodDefsArr = objToArrK(periodDefs);

export const registrationDatePeriodDefs = {
        "lt_1d": {h: "< 24h", c: "#b2d1ff", tip: "Devices registered within the last 24 hours."},
        "lt_7d": {h: "< 7d", c: "#86a8fc", tip: "Devices registered within the last 7 days."},
        "lt_1m": {h: "< 1m", c: "#0090d9", tip: "Devices registered within the last month."},
        "gt_1m": {h: "> 1m", c: "#0e4380", tip: "Devices registered more than a month ago."},
    }, registrationDatePeriodDefsArr = objToArrK(registrationDatePeriodDefs);

export const benchmarkLevelOpts = [
    {k: undefined, h: "All"},
    {k: "*Level_1*", h: "Level 1"},
    {k: "*Level_2*", h: "Level 2"},
    {k: "*STIG*", h: "STIG"}
];

export const resolveKBUrl = (path) => `https://knowledge-base.cloud.remedio.io${path}`;
